function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1_1_",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 63,
    x2: 32,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9F2FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0BB1D3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M53.586,49.172C52.83,48.416,51.825,48,50.757,48h-7.515c-0.534,0-1.036-0.208-1.415-0.586  l-6.5-6.5C34.739,40.324,33.955,40,33.121,40c-0.041,0-0.08,0.011-0.121,0.012V29h4c0.366,0,0.705-0.106,1-0.278  C38.295,28.894,38.634,29,39,29h16c1.103,0,2-0.897,2-2v-2c0-1.103-0.897-2-2-2h-0.656L32,5.513V4c0-1.654-1.346-3-3-3s-3,1.346-3,3  v1.513L3.656,23H3c-1.103,0-2,0.897-2,2v2c0,1.103,0.897,2,2,2h16c0.366,0,0.705-0.106,1-0.278C20.295,28.894,20.634,29,21,29h4v32  h-2.101c-0.464-2.279-2.485-4-4.899-4h-3V47h6c1.103,0,2-0.897,2-2v-2c0-1.103-0.897-2-2-2H3c-1.103,0-2,0.897-2,2v2  c0,1.103,0.897,2,2,2h6v10H6c-2.757,0-5,2.243-5,5v1h51.387l-2.959-8.877c0.275,0.098,0.53,0.25,0.744,0.463l7.5,7.5  C58.261,62.676,59.045,63,59.879,63C61.6,63,63,61.6,63,59.879c0-0.822-0.333-1.626-0.914-2.207L53.586,49.172z M3,43h18l0.001,2H3  V43z M11,47h2v10h-2V47z M3.171,61C3.584,59.836,4.696,59,6,59h12c1.304,0,2.416,0.836,2.829,2H3.171z M38.414,52.828  c0.379,0.378,0.819,0.671,1.299,0.87L37.279,61H33V47.414L38.414,52.828z M55.001,27H39v-2h16L55.001,27z M39,23  c-0.366,0-0.705,0.106-1,0.278C37.705,23.106,37.366,23,37,23h-0.279L31.646,7.775L51.1,23H39z M29.279,7l5.333,16H23.388l5.333-16  H29.279z M28,4c0-0.552,0.449-1,1-1s1,0.448,1,1v1h-2V4z M3,27v-2h7v-2H6.9L26.354,7.775L21.279,23H21c-0.366,0-0.705,0.106-1,0.278  C19.705,23.106,19.366,23,19,23h-7v2h7v2H3z M21,25h16v2H21V25z M27,29h4v11.845c-0.611,0.57-1,1.376-1,2.276  c0,0.822,0.333,1.626,0.914,2.207L31,45.414V61h-4V29z M39.388,61l2.333-7h5.558l2.334,7H39.388z M59.879,61  c-0.3,0-0.581-0.116-0.793-0.328l-7.5-7.5C50.83,52.416,49.825,52,48.757,52h-7.515c-0.534,0-1.036-0.208-1.415-0.586l-7.5-7.5  C32.12,43.705,32,43.416,32,43.121C32,42.503,32.503,42,33.121,42c0.3,0,0.581,0.116,0.793,0.328l6.5,6.5  C41.17,49.584,42.175,50,43.243,50h7.515c0.534,0,1.036,0.208,1.415,0.586l8.5,8.5C60.88,59.295,61,59.584,61,59.879  C61,60.497,60.497,61,59.879,61z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.7f7360c4cc54d822b142825179dbf51c.svg";
export { ForwardRef as ReactComponent };